import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import flags from '../../assets/flags/index.js';

var flagCache = new Map();
var fetchFlag = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(country) {
    var _yield$flags$country, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!flagCache.has(country)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", flagCache.get(country));
        case 2:
          if (flags[country]) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", null);
        case 4:
          _context.next = 6;
          return flags[country]();
        case 6:
          _yield$flags$country = _context.sent;
          data = _yield$flags$country["default"];
          flagCache.set(country, data);
          return _context.abrupt("return", data);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchFlag(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { fetchFlag as default, fetchFlag };
//# sourceMappingURL=Flag.helper.js.map
